import { render, staticRenderFns } from "./companyMember.vue?vue&type=template&id=21e4fbf3&scoped=true"
import script from "./companyMember.vue?vue&type=script&lang=js"
export * from "./companyMember.vue?vue&type=script&lang=js"
import style0 from "./companyMember.vue?vue&type=style&index=0&id=21e4fbf3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e4fbf3",
  null
  
)

export default component.exports